import { Button, Tooltip } from "@mui/material";
import Decimal from "break_infinity.js";
import { prettifyNumber } from "../../lib/prettifier";
import React, { useEffect, useMemo, useState } from "react";
import { GameContext } from "../../provider/GameProvider";
import { set } from "lodash";
import { isAchievementUnlocked } from "../../types/achievements";

function ProgressButton({
  progress,
  onClick,
  content,
  times10Progress,
  multiplier,
  isFirstProducer,
}: {
  progress: number;
  onClick: () => void;
  content?: React.ReactNode | string;
  times10Progress: number;
  multiplier: Decimal;
  isFirstProducer: boolean;
}) {
  const { game } = React.useContext(GameContext);
  const calculatedProgress =
    times10Progress * 10 + Math.floor(progress / 10) * 10;

  const updateButtonColor = useMemo(() => {
    return (
      !isAchievementUnlocked(1, game.unlockedAchievementIds) && isFirstProducer
    );
  }, [game.unlockedAchievementIds, isFirstProducer]);
  const [borderColor, setBorderColor] = useState("#2196f3");
  useEffect(() => {
    const timeout = setTimeout(() => {
      console.log("updateButtonColor", updateButtonColor);
      if (updateButtonColor) {
        if (borderColor === "#2196f3") {
          setBorderColor("yellow");
        } else {
          setBorderColor("#2196f3");
        }
      } else {
        setBorderColor("#2196f3");
      }
    }, 500);
    return () => clearTimeout(timeout);
  }, [borderColor, updateButtonColor]);

  return (
    <div style={{ position: "relative", width: "130px" }}>
      <Tooltip
        title={`x${prettifyNumber(multiplier)} Multiplier`}
        placement="left"
        arrow
      >
        <Button
          variant="outlined"
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            onClick();
          }}
          style={{
            overflow: "hidden",
            backgroundColor: "transparent",
            width: "100%",
            height: "100%",
            padding: 0,
            borderColor: borderColor,
          }}
        >
          <div
            style={{
              zIndex: 5,
              textTransform: "none",
              fontSize: 12,
              lineHeight: "1.5",
              padding: 2,
            }}
          >
            {content}
          </div>

          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: `${calculatedProgress}%`,
              height: "100%",
              backgroundColor: "#4169E1",
              transition: "width 0.2s ease-in-out",
            }}
          />
          <div
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: `${times10Progress * 10}%`,
              height: "100%",
              backgroundColor: "blue",
              transition: "width 0.2s ease-in-out",
            }}
          />
        </Button>
      </Tooltip>
    </div>
  );
}

export default ProgressButton;
